import * as React from 'react'
import { NextPage, NextPageContext } from 'next'
import { stringify } from 'query-string'
import { BroodModel } from '@Interfaces'
import { BroodService } from '@Services'
import { GeneralActions } from '@Actions'

import { SimpleTemplate } from '@Components'

const SearchPage: NextPage<any> = ({ statusCode,
  ...props }) => {
  const meta = {
    title: '',
    description: '',
    keywords: '',
    excludeFromSitemap: false,
    extraMetadata: '',
    oGtags: null,
    url: '',
  }

  return <SimpleTemplate meta={meta} blocks={props.blocks} query={props.query} otherLanguageUrl={props.otherLanguageUrl} />
}

SearchPage.getInitialProps = async (ctx: NextPageContext) => {
  if (ctx.asPath) {
    const query = ctx.query
    const searchTerm = query.searchTerm as string || ''
    const categories = query.categories as string || ''
    const page = query.pageNumber ? parseInt(query.pageNumber as string, 10) : 1

    if (searchTerm) {
      (ctx as any).store.dispatch(GeneralActions.SetGeneralSearchTerm(searchTerm))
    }

    if (categories) {
      (ctx as any).store.dispatch(GeneralActions.SetCategorieSearch(categories))
    } else {
      (ctx as any).store.dispatch(GeneralActions.SetCategorieSearch(''))
    }

    const response: BroodModel.GetPageResponse = await BroodService.GetSearchPage(
      searchTerm,
      categories,
      page,
    )

    if (Object.keys(response).length === 0) {
      if (ctx.res) {
        ctx.res.statusCode = 500
      }

      return {
        meta: {
          title: 'Pagina is niet bereikbaar',
          description: 'Neem contact op met de systeembeheerder, of probeer het later nog eens.',
        },
        statusCode: 500,
      }
    }

    // add querystring to response.data
    if (response.data) {
      response.data.query = stringify(query)
      return response.data as any
    }
  }

  return {
    meta: {
      title: 'Default title',
      description: 'Default description',
    },
    blocks: {
      main: [],
    },
  }
}

export default SearchPage
